(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import moment from 'moment';
import { ProfileManager } from '@kailona/core';
export default function mapTCXtoFHIR(tcxData) {
  var fhirPatientId = ProfileManager.activePatientId;

  if (!fhirPatientId) {
    throw new Error('Invalid patient id');
  }

  var parser = new DOMParser();
  var xmlDoc = parser.parseFromString(tcxData, 'text/xml');
  var fhirObservations = [];
  var fhirBaseObservation = {
    resourceType: 'Observation',
    status: 'final',
    category: [{
      coding: [{
        system: 'http://hl7.org/fhir/ValueSet/observation-category',
        code: 'activity',
        display: 'Activity'
      }]
    }],
    code: {
      coding: [{
        system: 'http://loinc.org',
        code: '62812-3',
        display: 'Physical activity and physical fitness'
      }],
      text: 'Activity'
    },
    subject: {
      reference: "Patient/".concat(fhirPatientId)
    }
  }; // TrainingCenterDatabase

  var trainingCenterDatabase = xmlDoc.getElementsByTagName('TrainingCenterDatabase')[0]; // Author

  var author = trainingCenterDatabase.getElementsByTagName('Author')[0];
  var authorName = author.getElementsByTagName('Name')[0].textContent; // Activities

  var activities = trainingCenterDatabase.getElementsByTagName('Activities')[0];
  activities.getElementsByTagName('Activity').forEach(function (activity) {
    var notes = activity.getElementsByTagName('Notes')[0].textContent;
    var fhirBaseObservationActivity = Object.assign(fhirBaseObservation, {
      note: [{
        authorString: authorName,
        text: notes
      }]
    });
    activity.getElementsByTagName('Lap').forEach(function (lap) {
      var startTimeAttribute = lap.attributes['StartTime'];
      var startTime = startTimeAttribute && startTimeAttribute.value;

      if (!startTime) {
        return;
      }

      var totalTimeSecondsElements = lap.getElementsByTagName('TotalTimeSeconds');
      var totalTimeSeconds = totalTimeSecondsElements.length && parseInt(totalTimeSecondsElements[0].textContent);

      if (!totalTimeSeconds) {
        return;
      }

      var startTimeMoment = moment(startTime);
      var endTimeMoment = startTimeMoment.clone().add(totalTimeSeconds, 'seconds');
      var component = [];
      lap.childNodes.forEach(function (lapChildNode) {
        switch (lapChildNode.nodeName) {
          case 'DistanceMeters':
            component.push({
              code: {
                coding: [{
                  system: 'http://loinc.org',
                  code: '55430-3',
                  display: 'Walking distance'
                }],
                text: 'Distance'
              },
              valueQuantity: {
                value: parseFloat(lapChildNode.textContent),
                unit: 'm',
                system: 'http://unitsofmeasure.org',
                code: 'm'
              }
            });
            break;

          case 'Calories':
            component.push({
              code: {
                coding: [{
                  system: 'http://loinc.org',
                  code: '55421-2',
                  display: 'Calories burned'
                }],
                text: 'Calories'
              },
              valueQuantity: {
                value: parseInt(lapChildNode.textContent),
                unit: 'cal',
                system: 'http://unitsofmeasure.org',
                code: 'cal'
              }
            });
            break;
        }
      });
      fhirObservations.push(Object.assign(fhirBaseObservationActivity, {
        effectivePeriod: {
          start: startTimeMoment.toISOString(),
          end: endTimeMoment.toISOString()
        },
        component: component
      }));
    });
  });
  return fhirObservations;
}
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(mapTCXtoFHIR, "mapTCXtoFHIR", "/home/runner/html/nextcloud/apps/ehr/js/plugins/activities/src/mappers/mapTCXtoFHIR.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();